import pick from './helpers/pick';

export const decodeQueryString = (queryString: string): Record<string, string> =>
  queryString
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    .substr(1)
    .trim()
    .split('&')
    .filter((it) => it)
    .map((pairString) => pairString.split('=').map(window.decodeURIComponent))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value || null }), {});

export const encodeQueryString = (queryObject: Record<string, string | null | number>) => {
  const keys = Object.keys(queryObject);
  if (keys.length > 0) {
    const pairStrings = keys.map(
      (key) => `${key}=${queryObject[key] ? encodeURIComponent(queryObject[key]) : ''}`,
    );
    return `?${pairStrings.join('&')}`;
  }
  return '';
};

export const mergeQueryStringAndQueryObject = (
  queryString: string,
  queryObject: Record<string, string | null | number>,
) => encodeQueryString({ ...decodeQueryString(queryString), ...queryObject });

export const whitelistQueryString = (search: string, whitelist = ['filter']) =>
  encodeQueryString(pick(decodeQueryString(search), whitelist));
